// @flow
import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.malqueridaCup',
  title: 'hardCoded.title.malqueridaCup',
  slug: titleToSlug('hardCoded.title.malqueridaCup'),
  catalog: {
    title: 'hardCoded.catalog.title.malqueridaCup',
    catalogMedia,
    price: numberToCurrency('15'),
    color: '#007df6'
  }
}
